import { useState, useEffect } from 'react';

function useLiveClock(intervalMs = 3600000) {
    const [date, setDate] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => setDate(new Date()), intervalMs);
        return () => clearInterval(timer);
    }, [intervalMs]);

    return date;
}

export default useLiveClock;
